import script from "./PCSettingsBlockPalletizingPoints.vue?vue&type=script&setup=true&lang=js"
export * from "./PCSettingsBlockPalletizingPoints.vue?vue&type=script&setup=true&lang=js"

import "./PCSettingsBlockPalletizingPoints.vue?vue&type=style&index=0&id=38b6b405&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38b6b405"]])

export default __exports__